namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmVlastnostTypSubjektu extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmVlastnostTypSubjektuReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmVlastnostTypSubjektuObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmVlastnostTypSubjektuObj());
            this.detailObj.createBase({
                contentName: "detailAdmVlastnostTypSubjektu",
                contentCaption: "jres:33000409",  //RC 33000409 : Povolená vlastnost, struktura nebo profil pro typ objektu
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmVlastnostTypSubjektu", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }

        
    }


    export class DetailAdmVlastnostTypSubjektuObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmVlastnostTypSubjektuReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["stat_txt"]
        }

        setSxsDetail(): string {
            return "{0}#{1}#{2}#".format((this.data.typ_obj) ? this.data.typ_obj.toString() : "", (this.data.ixs) ? this.data.ixs : "", (this.data.ico) ? this.data.ico : "" );
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmVlastnostTypSubjektuSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            data.ixs = this.getIxs();
            (this.cnt.isl.AdmVlastnostTypSubjektu.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase();
                    this.showSuccessSave(close);
                    if (close == true) {
                        this.closeAction(true).done(() => { this.cnt.close() });
                    } else
                        this.reloadDataBase();
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        private getIxs(): string | null {
            var form = this.cnt.findForms("{0}form".format(this.options.contentName));
            var typ = form.findFields("typ_vps").gfield("getValue");
            if (typ.typ_vps != null && typ.typ_vps != undefined) {
                switch (typ.typ_vps) {
                    case 0:
                        return form.findFields("ixs_pro").gfield("getValue")["ixs_pro"];
                    case 10:
                        return form.findFields("ixs_stv").gfield("getValue")["ixs_stv"];
                    case 20:
                        return form.findFields("ixs_vla").gfield("getValue")["ixs_vla"];
                }
            }
            return null
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmVlastnostTypSubjektu", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmVlastnostTypSubjektu.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} {1}".format(this.generContentCaption(), (this.data.typ_obj_txt) ? this.data.typ_obj_txt : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeSelectField("ico", Gordic.Prefabs.Select.ekosico(), { model: "model.ico=value.ico" })
            this.MakeSelectField("typ_vps", Gordic.Prefabs.Select.admGincvps(), {
                model: "model.typ_vps=value.typ_vps ",
                disabled: (this.data.ixs != null && this.data.ixs != undefined) ? true : false,
                change: (ev, ctx) => {
                    var form = this.cnt.findForms("{0}form".format(this.options.contentName))
                    var fieldVla = form.findFields("ixs_vla");
                    var fieldPro = form.findFields("ixs_pro");
                    var fieldStv = form.findFields("ixs_stv");
                    fieldVla.gfield("setValidators", []);
                    fieldPro.gfield("setValidators", []);
                    fieldStv.gfield("setValidators", []);
                    fieldVla.gfield("setValue", null);
                    fieldPro.gfield("setValue", null);
                    fieldStv.gfield("setValue", null);
                    this.HideField("ixs_vla");
                    this.HideField("ixs_pro");
                    this.HideField("ixs_stv");
                    if (ctx.value) {
                        if (!Array.isArray(ctx.value)) {
                            switch (ctx.value.typ_vps) {
                                case 0:
                                    this.ShowField("ixs_pro");
                                    fieldPro.gfield("setValidators", [new Gordic.Validators.Required({ stopping: true })])
                                    fieldPro.gfield("option", "flag", "required");
                                    if (this.data.ixs)
                                        fieldPro.gfield("setValue", { ixs_pro: this.data.ixs }, { valid: false });
                                    form.findFormRows("row_ixs").find("label").html("jres:33000410") //RC 33000410 : Profil
                                    break;
                                case 10:
                                    this.ShowField("ixs_stv");
                                    fieldStv.gfield("setValidators", [new Gordic.Validators.Required({ stopping: true })])
                                    fieldStv.gfield("option", "flag", "required");
                                    if (this.data.ixs)
                                        fieldStv.gfield("setValue", { ixs_stv: this.data.ixs }, { valid: false });
                                    form.findFormRows("row_ixs").find("label").html("jres:29931622") //RC 33000410 : Profil
                                    break;
                                case 20:
                                    this.ShowField("ixs_vla");
                                    fieldVla.gfield("setValidators", [new Gordic.Validators.Required({ stopping: true })])
                                    fieldVla.gfield("option", "flag", "required");
                                    if (this.data.ixs)
                                        fieldVla.gfield("setValue", { ixs_vla: this.data.ixs }, { valid: false });
                                    form.findFormRows("row_ixs").find("label").html("jres:29932128") //RC 33000410 : Profil
                                    break;
                            }
                        }
                        if (this.data.ixs) {
                            this.cnt.findFields("typ_vps").gfield("disable")
                        }
                    }
                }
            })
            this.MakeSelectField("ixs", Gordic.Prefabs.Select.ginsvla(), {
                model: "model.ixs=value.ixs_vla",
                name: "ixs_vla",
                disabled: this.data.ixs ? true : false,
                serverFilters: {
                    aktivita: 100
                }
            })
            this.MakeSelectField("ixs", Gordic.Prefabs.Select.ginspro(), {
                model: "model.ixs=value.ixs_pro",
                name: "ixs_pro",
                disabled: this.data.ixs ? true : false,
                serverFilters: {
                    aktivita: 100,
                    priz_vir: 0
                },
            })
            this.MakeSelectField("ixs", Gordic.Prefabs.Select.ginsstv(), {
                model: "model.ixs=value.ixs_stv",
                name: "ixs_stv",
                disabled: this.data.ixs ? true : false,
                serverFilters: {
                    aktivita: 100,
                    priz_vir: 0
                },
            })
            this.MakeSelectField("typ_obj", Gordic.Prefabs.Select.admGincobj(), { model: "model.typ_obj=value.typ_obj" })
            this.MakeField("poznamka")
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });

        }

        private generContentCaption(): string {
            if (this.data.typ_vps != null && this.data.typ_vps != undefined) {
                return "jres:33000424";
            } else {
                return "jres:33000409";
            }
        }
    }
}